import { ReactNode } from "react";
import { Helmet } from "react-helmet";

export type BaseLayoutType = {
  title: string;
  children: ReactNode;
};

export default function BaseLayout({ title, children }: BaseLayoutType) {
  return (
    <section className="w-full flex flex-col items-center justify-start h-full">
      <Helmet>
        <title>Wicode | {title}</title>
      </Helmet>
      {children}
    </section>
  );
}
